export class ActivityEndpoint {
  activity() {
    return '/hydra/v1/activity';
  }
}

